import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import dayjs from "dayjs";
import SimpleBox from "../layout/container/SimpleBox";
import Title from "../typography/Title";
import Game from "./Game";

const DayGame = ({ gamesOfDay }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box display="flex" flexDirection="column" width="100%"
            sx={{ boxShadow: theme.shadows[8], paddingY: theme.spacing(6), backgroundColor: theme.palette.white.dark }}>
            <SimpleBox justifyContent="start" fullWidth={true}>
                <Title fontWeight="bold" variant="h3" pl={14} label={dayjs(gamesOfDay.date).format("DD MMM YYYY")} />
            </SimpleBox>
            <SimpleBox pl={6} pr={6} mt={6} flexDirection="column" justifyContent="center" fullWidth={true}>
                {
                    gamesOfDay.games.map((game, gameIdx) => {
                        const isLastGame = gameIdx === gamesOfDay.games.length - 1;
                        const borderBottom = !isLastGame ? `3px solid ${theme.palette.secondary.main}` : "none";
                        const paddingTop = gameIdx === 0 ? theme.spacing(0) : theme.spacing(6);
                        const paddingBottom = isLastGame ? theme.spacing(0) : theme.spacing(6);
                        return (
                            <Box key={gameIdx} sx={{ width: "100%", borderBottom, paddingTop, paddingBottom }}>
                                <Game game={game} />
                            </Box>
                        )
                    })
                }
            </SimpleBox>
        </Box>
    )
}

export default DayGame;
